export default "__VITE_ASSET__D1R8Kdpf__"